import { Card, MEDIA_QUERY, Typography } from '@sky-distribution/react-commons-ui';
import styled, { css } from 'styled-components';
import { Tenant, TENANT_NAME } from '../../config/tenants';

const isTuw = TENANT_NAME === Tenant.TUW;

export const InfoCardWrapper = styled(Card)`
  background-color: ${({ theme }) => theme.palette.commons.background.infotip};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: start;
  margin: 0.5rem 0;
  padding: 1rem;
  ${MEDIA_QUERY.below('sm')} {
    padding: 10px;
  }
`;

export const InfoCardContent = styled(Typography)`
  margin: 0;
  white-space: pre-line;
  color: ${({ theme }) => theme.palette.text.paragraph.primary};

  ol {
    margin: 0;
    padding: 0;
    margin-left: 1.2rem;
    display: ${isTuw ? 'block' : 'flex'};
    align-items: ${isTuw ? 'flex-start' : 'center'};
  }

  ol li,
  ol li p {
    margin: 0;
    padding: 0;
  }

  ${isTuw &&
  css`
    ol,
    ol li,
    ol li p {
      margin: 0 !important;
      padding: 0 !important;
    }

    ol li > p {
      display: inline;
    }
  `}
`;

export const InfoCardParagraph = styled(Typography)`
  margin: 0;
  white-space: pre-line;
  color: ${({ theme }) => theme.palette.text.paragraph.primary};
`;

export const PanelWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledInstruction = styled(Typography)`
  cursor: pointer;
  color: ${({ theme }) => theme.palette.brand.color};
`;
export const InstructionTitle = styled(Typography)`
  font-weight: 600;
  color: ${({ theme }) => theme.palette.text.paragraph.primary};
`;

export const InstructionContent = styled(Typography)`
  font-weight: 500;
  color: ${({ theme }) => theme.palette.text.paragraph.primary};
  line-height: 1.2;
`;

export const TuwInstructionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-left: 46px;
`;

export const TuwInstructionItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.25rem;

  p {
    margin: 0;
  }
`;

export const TuwInstructionNumber = styled.span`
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-weight: 700;
  line-height: 1.4;
`;
